module.exports = __webpack_public_path__ + "img/CHN@3x.85689ae5.png";